import { useState } from "react";
import { NavLink, Link } from "react-router-dom";
import { Menu, X, ChevronRight } from "lucide-react";
import BookingDialog from "@/components/BookingDialog";

const NAV = [
  { to: "/", label: "Home" },
  { to: "/about", label: "About" },
  { to: "/private-sessions", label: "Private Sessions" },
  { to: "/faqs", label: "FAQs" },
  { to: "/contact", label: "Contact" },
];

export default function Header() {
  const [open, setOpen] = useState(false);

  return (
    <header
      data-testid="site-header"
      className="fixed top-0 inset-x-0 z-50 backdrop-blur-xl bg-white/80 border-b border-slate-200"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-20 flex items-center justify-between">
        <Link to="/" data-testid="logo-link" className="flex items-center gap-3 group">
          <img src="/logo.jpg" alt="Advanced Coaching" className="w-12 h-12 rounded-full object-cover ring-2 ring-[#1E3A8A]/20 group-hover:ring-[#F59E0B] transition" />
          <div className="leading-tight hidden sm:block">
            <div className="font-display font-bold uppercase tracking-tight text-lg text-slate-900">
              Advanced <span className="text-[#1E3A8A]">Coaching</span>
            </div>
            <div className="text-[10px] uppercase tracking-[0.25em] text-slate-500">Est. 2025</div>
          </div>
        </Link>

        <nav className="hidden lg:flex items-center gap-1">
          {NAV.map((n) => (
            <NavLink
              key={n.to}
              to={n.to}
              data-testid={`nav-${n.label.toLowerCase().replace(/\s+/g, "-")}`}
              end={n.to === "/"}
              className={({ isActive }) =>
                `px-4 py-2 text-sm font-semibold uppercase tracking-wider transition-colors ${
                  isActive ? "text-[#1E3A8A]" : "text-slate-700 hover:text-[#1E3A8A]"
                }`
              }
            >
              {n.label}
            </NavLink>
          ))}
        </nav>

        <div className="hidden lg:flex items-center">
          <BookingDialog
            trigger={
              <button data-testid="header-book-btn" className="btn-gold text-sm">
                Book Now <ChevronRight className="w-4 h-4" />
              </button>
            }
          />
        </div>

        <button
          data-testid="mobile-menu-toggle"
          aria-label="Open menu"
          className="lg:hidden text-slate-900 p-2"
          onClick={() => setOpen((o) => !o)}
        >
          {open ? <X /> : <Menu />}
        </button>
      </div>

      {open && (
        <div data-testid="mobile-menu" className="lg:hidden border-t border-slate-200 bg-white/95 backdrop-blur-xl">
          <div className="px-4 py-4 flex flex-col gap-1">
            {NAV.map((n) => (
              <NavLink
                key={n.to}
                to={n.to}
                end={n.to === "/"}
                onClick={() => setOpen(false)}
                data-testid={`mobile-nav-${n.label.toLowerCase().replace(/\s+/g, "-")}`}
                className={({ isActive }) =>
                  `px-3 py-3 rounded-lg text-sm font-semibold uppercase tracking-wider ${
                    isActive ? "bg-slate-50 text-[#1E3A8A]" : "text-slate-700"
                  }`
                }
              >
                {n.label}
              </NavLink>
            ))}
            <div className="pt-2">
              <BookingDialog
                trigger={
                  <button data-testid="mobile-book-btn" className="btn-gold w-full justify-center text-sm">
                    Book Now <ChevronRight className="w-4 h-4" />
                  </button>
                }
              />
            </div>
          </div>
        </div>
      )}
    </header>
  );
}
